import { makeStyles } from '@material-ui/core';
import colours from '../../../abstracts/colours';

const useStyles = makeStyles({
  root: {
    width: 52,
    height: 32,
    padding: 1,
  },
  switchBase: {
    padding: 3,
    opacity: 1,
    '&$checked': {
      transform: 'translateX(20px)',
      color: colours.white,
      '&[aria-disabled="false"] + $track': {
        backgroundColor: colours.scienceBlue,
        opacity: 1,
      },
    },
    '&$focusVisible + $track': {
      border: `solid 2px ${colours.black}`,
      opacity: 1,
    },
    '&[aria-disabled="true"]': {
      color: colours.silverThree,
      cursor: 'default',
      '& + $track': {
        opacity: 1,
        backgroundColor: colours.bonJour,
      },
    },
  },
  thumb: {
    width: 26,
    height: 26,
  },
  track: {
    borderRadius: 15,
    backgroundColor: colours.iron,
    opacity: 1,
  },
  disabled: {},
  checked: {},
  focusVisible: {},
});

export default useStyles;
